export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b3c18419f156eb1b11b0fde6eec7c24e.jpg"
          alt="Professional solar repair and electrical service technician"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/25"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-transparent to-black/15"></div>
        <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-stone-950/40 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-28 pb-20">
        <div className="max-w-[620px]">

          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2.5 mb-7">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map(s => (
                <div key={s} className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-star-fill text-amber-400 text-xs"></i>
                </div>
              ))}
            </div>
            <span className="text-white/70 text-sm tracking-wide">21+ Years · East Bay&apos;s Energy & Electrical Experts</span>
          </div>

          {/* H1 — repair/electrical focused */}
          <h1
            className="text-5xl md:text-6xl lg:text-[66px] font-black text-white leading-[1.05] tracking-tight mb-6"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Fix, Optimize &amp;<br />
            Protect Your<br />
            <span className="text-amber-400">Energy System.</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg text-white/75 leading-relaxed mb-10 max-w-[500px]">
            Solar repair &amp; maintenance, battery backup, EV charging, and full electrical services — one licensed team, one call, zero guesswork.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 mb-12">
            <button
              onClick={() => scrollTo("#contact")}
              className="group bg-amber-500 hover:bg-amber-400 text-white font-bold px-8 py-4 rounded-lg text-base transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2.5"
            >
              Get a Free Diagnostic Estimate
              <div className="w-5 h-5 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-line"></i>
              </div>
            </button>
            <a
              href="tel:9258723408"
              className="border border-white/30 hover:border-white/60 hover:bg-white/10 text-white font-semibold px-8 py-4 rounded-lg text-base transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2.5 backdrop-blur-sm"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-amber-400"></i>
              </div>
              (925) 872-3408
            </a>
          </div>

          {/* Trust micro-row */}
          <div className="flex flex-wrap gap-x-6 gap-y-2.5">
            {[
              { icon: "ri-shield-check-fill", text: "A+ BBB Rated" },
              { icon: "ri-award-fill", text: "Licensed & Insured" },
              { icon: "ri-tools-fill", text: "Solar Repair Specialists" },
              { icon: "ri-24-hours-line", text: "24/7 Emergency" },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-1.5">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-amber-400 text-sm`}></i>
                </div>
                <span className="text-white/65 text-sm">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5">
        <div className="w-px h-10 bg-gradient-to-b from-transparent to-white/30"></div>
        <div className="w-4 h-4 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-line text-white/40 text-sm"></i>
        </div>
      </div>
    </section>
  );
}
